import React from "react";
import Link from "next/link";
const WhatsAppButton = ({ phoneNumber, productLink, quantity }) => {
  const message = `Hi, I'm interested in this product: ${productLink} for  Quantity: ${quantity}`;
  const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
    message
  )}`;

  return (
    <Link
      href={url}
      target="_blank"
      className="w-full text-[13px] md:text-base md:leading-4 inline-flex items-center cursor-pointer transition ease-in-out duration-300 font-semibold font-body text-center justify-center border-0 border-transparent rounded-md placeholder-white focus-visible:outline-none focus:outline-none h-8 lg:h-10 px-4 bg-brown text-white py-2 transform-none normal-case hover:text-white hover:bg-darkBrown"
    >
      Enquire
    </Link>
  );
};

export default WhatsAppButton;
